var w_counts = 0;
var w_outs = "<div class='noresult'>" + w_counts + " product found</div>";
jQuery(function (e) {

    var wldata = JSON.parse(localStorage.getItem("wishlist_data"));
    if (wldata != null) {
        if(wldata.length!=0){
          w_outs = "";
        }
        var isHave = false;
        var isIndex = 0;
        $.each(wldata, function (key, value) {
            var product_handle = value["product_handle"];
            var pid = value["product_id"];
            var url = "/products/" + product_handle;
            $.ajax({
                type: "get",
                url: "/products/" + product_handle + ".json",
                dataType: "json",
                async: false,
                success: function (data) {
                    console.log(data);
                    var imgSrc = data.product.image.src;
                    var title = data.product.title;
                    var price = "";
                  	var ms=Cookies.get("cart_currency");
                    if (pid != null) {
                        url += "?variant=" + pid;
                        $.each(data.product.variants, function (i, vs) {
                            if (vs["id"] == pid) {
                                var image_id = vs["image_id"];
                              	price="$"+vs["price"]+" "+ms;
                                title += " - " + vs["title"];
                                $.each(data.product.images, function (j, is) {
                                    if (is["id"] == image_id) {
                                        imgSrc = is["src"];
                                    }
                                })
                            }
                        })
                    } else {
                      price="$"+data.product.variants[0].price+" "+ms;
                    }
                    w_outs += "<div class='wishblock'>";
                    if(pid!=null){
                      	w_outs += "<div class='wish_img'><i class='far fa-trash-alt wdele' data-product-handle='"+product_handle+"' data-product-id='"+pid+"'></i><a href='" + url + "'><img src=" + imgSrc + " /></a></div>";
                    }else{                    
                    	w_outs += "<div class='wish_img'><i class='far fa-trash-alt wdele' data-product-handle='"+product_handle+"'></i><a href='" + url + "'><img src=" + imgSrc + " /></a></div>";
                    }
                    w_outs += "<div class='title'><a href='" + url + "'>" + title + "</a></div>";
                    w_outs += "<div class='price'>" + price + "</div>";
                    w_outs += "</div>";

                },
                error: function (error) {
                    console.log(error);
                }
            });
        });
    }
    $(".wishlist-list").append(w_outs);
})